import React from 'react';
import { getHoverOptions } from '../../Utils/commonUtils';

// Structure:
// props: {
//   icon: <>,
//   iconClass: <>,
//   className: <>
//   showTextExplicitly: < true || false >,
//   content: <>
// }

const ChrTooltip = (props) => {
  const showTextExplicitly = props.showTextExplicitly;
  let iconOptions = {
    className: `${props.iconClass || "fa-solid fa-circle-info info-icon-color pt-2"} px-1`
  };
  let contentClassName = `${props.contentClass || "p-t-xxs"} px-1`;
  const hoverContent = showTextExplicitly ? "" : props.content;

  return (
    <div className={`d-flex flex-row ${props.className}`}>
      <i {...iconOptions} { ...getHoverOptions(hoverContent) } aria-label={props.ariaLabel} />
      {showTextExplicitly && <span className={contentClassName}>{props.content}</span>}
    </div>
  );
};

export default ChrTooltip;
